import { useUserStore } from '../../store/models';
import { isDevEmail, hasSuperAdminDevAccess } from '../../utils/devAccess';

function useEcalWorldAsDev () {
    const userStore = useUserStore();
    // Read the observed tokens so MobX resubscribes when a superadmin switches
    // publisher, or when the logged-in user/role is (re)established.
    void userStore.observed.publisher;
    void userStore.observed.isSuperAdmin;
    const publisherEmail = userStore.publisher?.email || '';

    // Either the impersonated publisher's own email is allowed, or the logged-in
    // superadmin's own email is — so a superadmin dev can manage any publisher's
    // ECAL World settings regardless of that publisher's own email.
    const devAccess = isDevEmail(publisherEmail) ||
        hasSuperAdminDevAccess(userStore.isSuperAdmin, userStore.user?.email);

    return {
        devAccess,
    };
}

export default useEcalWorldAsDev;
